import axios from 'axios';
import {
  CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CONFIG_BEGIN,
  CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CONFIG_SUCCESS,
  CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CONFIG_FAILURE,
  CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { toast } from 'react-toastify';

export function addCustomComponentConfig(args = {}) {
  return (dispatch) => {
    dispatch({
      type: CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CONFIG_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/custom-component`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CONFIG_SUCCESS,
              data: res.data,
            });
            toast.success('Component Created Successfully');
            resolve(res);
          } else {
            dispatch({
              type: CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CONFIG_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CONFIG_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddCustomComponentConfigError() {
  return {
    type: CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CONFIG_BEGIN:
      return {
        ...state,
        addCustomComponentConfigPending: true,
        addCustomComponentConfigError: null,
      };

    case CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CONFIG_SUCCESS:
      return {
        ...state,
        addCustomComponentConfigPending: false,
        addCustomComponentConfigError: null,
        customComponents: [...state.customComponents, action.data],
      };

    case CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CONFIG_FAILURE:
      return {
        ...state,
        addCustomComponentConfigPending: false,
        addCustomComponentConfigError: action.data.error,
      };

    case CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR:
      return {
        ...state,
        addCustomComponentConfigError: null,
      };

    default:
      return state;
  }
}
